import { render, staticRenderFns } from "./ContentFormComponent.vue?vue&type=template&id=373b3a41&scoped=true&"
import script from "./ContentFormComponent.vue?vue&type=script&lang=js&"
export * from "./ContentFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./ContentFormComponent.vue?vue&type=style&index=0&id=373b3a41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373b3a41",
  null
  
)

export default component.exports